const LeadData = [
  {
    index: 0,
    src: require('../assets/images/leads/atri.jpg'),
    name: 'Atri Bandyopadhyay',
    postion: 'Coordinator & UiPath Automation Tools',
    instagram: 'https://www.instagram.com/atriclicky?igsh=enQwdG5xNmNqdDNv',
    gamil: 'atricc03@gmail.com',
    linkedin: 'https://www.linkedin.com/in/atri-/',
  },
  {
    index: 3,
    src: require('../assets/images/leads/saptak.jpg'),
    name: 'Saptak Das',
    postion: 'Vice-Coordinator & Photography',
    instagram: 'https://www.instagram.com/s.saptak6?igsh=aWNuMHRyY2F4Z2Ni',
    gamil: 'saptakdas84@gmail.com',
    linkedin: 'https://www.linkedin.com/in/saptak-das-as1r2i3/',
  },
  {
    index: 16,
    src: require('../assets/images/leads/prasun.jpg'),
    name: 'Prasun Chakraborty',
    postion: 'Vice Coordinator & UiPath Automation Tools',
    instagram: 'https://www.instagram.com/uipathglobal/',
    gamil: 'URL',
    linkedin: 'https://www.linkedin.com/company/uipath/',
  },
  {
    index: 2,
    src: require('../assets/images/leads/deep3.jpg'),
    name: 'Deepsikha Das',
    postion: 'Associate Coordinator & Social Media Marketing',
    instagram:
      'https://www.instagram.com/deepsikhadas._?igsh=MWRsd2dmOXBzeG12ZQ==',
    gamil: 'deepsikha1104@gmail.com',
    linkedin: 'https://www.linkedin.com/in/devangi-das-667935209/',
  },
  {
    index: 5,
    src: require('../assets/images/leads/Anuska.jpg'),
    name: 'Anuska Maity',
    postion: 'Associate Coordinator & Content Writing',
    instagram: 'https://www.instagram.com/anuska.maity?igsh=cDRuZnc2bjZ5b21t',
    gamil: 'anuska09.maity@gmail.com',
    linkedin: 'https://www.linkedin.com/in/anuska-maity-706340253/',
  },
  {
    index: 7,
    src: require('../assets/images/leads/disha.jpg'),
    name: 'M Disha',
    postion: 'Associate Coordinator & RPA & AI',
    instagram:
      'https://www.instagram.com/thesecret_disha?igsh=MXMxOGQ1dGRoNzZqbg==',
    gamil: 'manvidisha0803@gmail.com',
    linkedin: 'https://www.linkedin.com/in/m-disha-5a1606213/',
  },
  {
    index: 8,
    src: require('../assets/images/leads/raima.jpeg'),
    name: 'Raima Mukherjee',
    postion: 'Web Development',
    instagram:
      'https://www.instagram.com/raimamukherjee29?igsh=dzRnNGliYzlwd2c0',
    gamil: 'raimamukherjee2910@gmail.com',
    linkedin: 'https://www.linkedin.com/in/raima-mukherjee-416089239/',
  },
  {
    index: 9,
    src: require('../assets/images/leads/chaman.jpg'),
    name: 'Chaman Kumar',
    postion: 'Graphic Designing',
    instagram: 'https://www.instagram.com/87nehal/',
    gamil: '87nehal@gmail.com',
    linkedin: 'https://www.linkedin.com/in/87nehal/',
  },
  {
    index: 4,
    src: require('../assets/images/leads/muktesh.jpg'),
    name: 'Muktesh Mishra',
    postion: 'Event Management',
    instagram:
      'https://www.instagram.com/som._.muktesh?igsh=MTQ4MzkzbmgwYm5yNA==',
    gamil: 'mukteshm24@gmail.com',
    linkedin: 'https://www.linkedin.com/in/muktesh-m/',
  },
  {
    index: 6,
    src: require('../assets/images/leads/Devangi.jpg'),
    name: 'Devangi Das',
    postion: 'Web Development',
    instagram:
      'https://www.instagram.com/exquisite_artemis?igsh=MWtudXlqbmltYjcwOQ==',
    gamil: 'devangiofficial@gmail.com',
    linkedin: 'https://www.linkedin.com/in/devangi-das-667935209/',
  },
  {
    index: 13,
    src: require('../assets/images/leads/Mousumi.jpg'),
    name: 'Mousumi Dey',
    postion: 'Social Media Marketing',
    instagram: 'https://www.instagram.com/mousumi.dey10?igsh=eWljZDh4cDR6OTFz',
    gamil: 'deymousumi1221@gmail.com',
    linkedin: 'https://www.linkedin.com/in/mousumi-dey-8961b3201/',
  },
  {
    index: 13,
    src: require('../assets/images/leads/saswat.jpg'),
    name: 'Saswat Jena',
    postion: 'Video Editing',
    instagram: 'https://www.instagram.com/sj_k_i_n_g?igsh=MXBtcG5ubXB0eGd2eg==',
    gamil: 'saswat.jena.2003sj@gmail.com',
    linkedin:
      'https://www.linkedin.com/in/saswat-jena-32098b1b8?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
  },
  {
    index: 1,
    src: require('../assets/images/leads/hritesh.jpeg'),
    name: 'Hritesh Mondal',
    postion: 'Web Development',
    instagram:
      'https://www.instagram.com/_acerowl.exe_?igsh=MTY2MGZ2MDJoeTVjdQ==',
    gamil: 'hritesh04.dev@gmail.com',
    linkedin:
      'https://www.linkedin.com/in/hritesh-mondal-855679287?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
  },
  {
    index: 10,
    src: require('../assets/images/leads/avirup2.jpg'),
    name: 'Avirup Banerjee',
    postion: 'Event Management',
    instagram:
      'https://www.instagram.com/avirupbanerjee_02/?igsh=Z2t4OHN1NDZiZWsz',
    gamil: 'bavirup2004@gmail.com',
    linkedin: 'https://www.linkedin.com/in/avirup-banerjee-949973243/',
  },
  {
    index: 11,
    src: require('../assets/images/leads/Komal.jpg'),
    name: 'Komal Jaiswal',
    postion: 'Social Media Marketing',
    instagram:
      'https://www.instagram.com/komaljaiswal237?igsh=MTlpNjdwMHk2bHpheg==',
    gamil: ' ',
    linkedin: 'https://www.linkedin.com/in/komal-jaiswal-9347522a6/',
  },
  {
    index: 12,
    src: require('../assets/images/leads/mayank.jpg'),
    name: 'Mayank Singhal',
    postion: 'Machine Learning',
    instagram: 'https://www.instagram.com/singhalmynk?igsh=ZzJrYWx1YTkzN3Vj',
    gamil: 'mayanksinghal831@gmail.com',
    linkedin: 'https://www.linkedin.com/in/singhalmynk/',
  },

  {
    index: 14,
    src: require('../assets/images/leads/sushant.jpg'),
    name: 'Sushant',
    postion: 'Video Editing',
    instagram: 'https://www.instagram.com/sj_k_i_n_g?igsh=MTdxbmp6M2xoMHdkcg==',
    gamil: 'sushantchoudhary586@gmail.com',
    linkedin: 'URL',
  },
  {
    index: 15,
    src: require('../assets/images/leads/akash.jpg'),
    name: 'Akash Sadhab',
    postion: 'Web development',
    instagram: 'https://www.instagram.com/mr_sadhab?igsh=bmU3NXkwM2V0dGFh',
    gamil: 'akashkumarsadhab@gmail.com',
    linkedin: 'https://www.linkedin.com/in/akash-sadhab/',
  },

  {
    index: 17,
    src: require('../assets/images/leads/Arojeet.jpg'),
    name: 'Arojeet Talukdar',
    postion: 'Event Management',
    instagram:
      'https://www.instagram.com/avirupbanerjee_02?igsh=Z2t4OHN1NDZiZWsz',
    gamil: 'arojeettaluckdar@gmail.com',
    linkedin: 'https://www.linkedin.com/in/arojeet-talukdar-2605001b2/',
  },
  {
    index: 18,
    src: require('../assets/images/leads/sourabh.png'),
    name: 'Sourabh Mohanty',
    postion: 'RPA & AI',
    instagram: 'https://www.instagram.com/sourabhrex?igsh=cXI5ZTZ4c2hmdjly',
    gamil: 'mohantysourabh007@gmail.com',
    linkedin: 'https://www.linkedin.com/in/sourabh-mohanty-44110a208/',
  },
]

export default LeadData
